import type { FieldErrors, FieldValues, UseFormRegister } from 'react-hook-form';
import { categoryOptions, interestedInOptions, subcategoryOptions } from './constants';

type FormSelectProps = {
  name: string;
  list: string[];
  multitple?: boolean;
  title: string;
  required?: boolean;
  register: UseFormRegister<FieldValues>;
};

export const FormSelect = ({
  name,
  list,
  multitple = false,
  title,
  required = true,
  register,
}: FormSelectProps) => (
  <select
    {...register(name)}
    multiple={multitple}
    title={title}
    required={required}
    data-testid="form-select"
  >
    {list.map((option) => (
      <option key={`${option}`} value={option}>
        {option}
      </option>
    ))}
  </select>
);

type MainFormProps = {
  register: UseFormRegister<FieldValues>;
  errors: FieldErrors<FieldValues>;
};

const MainForm = ({ register, errors = {} }: MainFormProps) => (
  <>
    Interested in:{' '}
    <small style={{ fontSize: '10px' }} data-testid="interested-in-hint">
      (Control or cmd click for multiple answers)
    </small>
    *
    <FormSelect
      list={interestedInOptions}
      multitple
      title="Interested in"
      name="00N1Q00000TGIOl"
      register={register}
    />
    {errors['00N1Q00000TGIOl'] && 'This field is required'}
    <br />
    <h3>Give Us Your Pitch!</h3>
    <label htmlFor="company">Company*</label>
    <input type="text" {...register('company', { maxLength: 40, required: true })} />
    {errors.company && 'This field is required'}
    <br />
    Company Bio:{' '}
    <small style={{ fontSize: '10px' }} data-testid="company-bio-hint">
      (max 255 characters)*
    </small>
    <textarea wrap="soft" {...register('00N1Q00000TGGY0', { maxLength: 255, required: true })} />
    {errors['00N1Q00000TGGY0'] && 'This field is required'}
    <br />
    Category*:
    <FormSelect
      list={categoryOptions}
      multitple={false}
      title="Category"
      name="00N1Q00000Sv0zd"
      register={register}
    />
    <br />
    Subcategory*:
    <FormSelect
      list={subcategoryOptions}
      multitple={false}
      title="Subcategory"
      name="00N1Q00000Sv0zi"
      register={register}
    />
    <br />
    Product Name(s)*:
    <textarea wrap="soft" {...register('00N1Q00000TGGYF', { required: true })} />
    {errors['00N1Q00000TGGYF'] && 'This field is required'}
    <br />
    Comp Value*:
    <input type="text" {...register('00N1Q00000TGIOg', { required: true })} />
    {errors['00N1Q00000TGIOg'] && 'This field is required'}
    <br />
  </>
);

export default MainForm;
